import script from "./BannerView.vue?vue&type=script&lang=ts&setup=true"
export * from "./BannerView.vue?vue&type=script&lang=ts&setup=true"

import "./BannerView.vue?vue&type=style&index=0&id=70b21a32&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70b21a32"]])

export default __exports__